export default {
    props: {
        api_route          : {
            type    : String,
            required: true
        },
        api_resurrect_route: {
            type    : String
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/ApiRoutes.js